import { GeneralCode, GeneralCodeType } from "models/content/GeneralCode";
import { useEffect, useState } from "react";
import { getGeneralCodes } from "utils/generalCodesUtils";

const MDTypography = require("components/MDTypography").default;

export const UnmatchReasons = ({ unmatchReasonsCodes }) => {
    const [unmatchReasons, setUnmatchReasons] = useState([] as GeneralCode[]);
  useEffect(() => {
    getGeneralCodes(GeneralCodeType.UnmatchReason).then((res) => {
        setUnmatchReasons(res);
        });
  }, []);
  return (
    <>
      {unmatchReasonsCodes.map((reasonCode, index) => (
        <MDTypography key={index} variant="body2" color="textSecondary">
          {unmatchReasons.find((reason) => reason.id === reasonCode)?.name}
        </MDTypography>
      ))}
    </>
  );
};
